import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { corporateWalletFlag } from './config/build';
import { detectInitialLanguage } from './utils/localeTag';

const en = !corporateWalletFlag ? require('./locales/en.json') : require('./locales/corporate_en.json');
// American English overrides only the strings that differ; everything else
// falls back to the British base (`en`). Corporate builds stay single-bundle
// and pinned to `en`, so the en-US override bundle is only loaded otherwise.
const enUS = !corporateWalletFlag ? require('./locales/en-US.json') : null;

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
	en: {
		translation: {
			...en
		}
	},
	...(enUS
		? {
				'en-US': {
					translation: {
						...enUS
					}
				}
		  }
		: {})
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		// `detectInitialLanguage` (in ./utils/localeTag) resolves a saved
		// preference, then the browser locale, then the British base. It already
		// short-circuits to `en` for corporate single-bundle builds, so no extra
		// guard is needed here.
		lng: detectInitialLanguage(),
		fallbackLng: 'en', // missing en-US strings fall back to the British base
		// you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage

		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
